import axios from 'axios';

const api = axios.create({
  baseURL: 'https://onfish-api.herokuapp.com/v2'
});

export const qrCodeApi = axios.create({
  baseURL: 'https://api.qrserver.com/v1/create-qr-code/'
})

export default api;